import { CatalogCurrency } from './catalog.plan.model';

export type CatalogAddOnType = 'feature' | 'quota' | 'bundle';

export interface CatalogAddOnPricing {
  billing_cycle: string;
  price: number;
  currency?: CatalogCurrency;
}

export interface CatalogAddOn {
  id?: string;
  _id?: string;
  name?: string;
  description?: string;
  type?: CatalogAddOnType;
  /** @deprecated Use pricing[] instead — this field is stale in the DB */
  price?: number;
  /** @deprecated Use pricing[].currency instead */
  currency?: CatalogCurrency;
  /** @deprecated Use pricing[].billing_cycle instead */
  billing_cycle?: 'monthly' | 'yearly' | 'one_time';
  pricing?: CatalogAddOnPricing[];
  compatible_plans?: string[];
  features?: Record<string, boolean>;
  quotas?: Record<string, number>;
  is_active?: boolean;
  sort_order?: number;
}

/**
 * Resolve the effective price for an addon given a billing cycle.
 * Reads from pricing[] (the source of truth); falls back to legacy price field.
 * Returns null when no price is available for the requested cycle.
 */
export function getAddonPriceForCycle(
  addon: CatalogAddOn,
  cycle: string
): { price: number; currency: string; billing_cycle: string } | null {
  if (addon.pricing && addon.pricing.length > 0) {
    const entry = addon.pricing.find(p => p.billing_cycle === cycle);
    if (entry) {
      return {
        price: entry.price,
        currency: entry.currency?.code ?? 'CHF',
        billing_cycle: entry.billing_cycle,
      };
    }
    return null;
  }
  // Legacy fallback — old price field (stale, but better than nothing)
  if (addon.price != null) {
    return {
      price: addon.price,
      currency: addon.currency?.code ?? 'CHF',
      billing_cycle: addon.billing_cycle ?? cycle,
    };
  }
  return null;
}
